import { render } from "./dataSyncManage.vue?vue&type=template&id=1f9caa27&scoped=true"
import script from "./dataSyncManage.vue?vue&type=script&lang=js"
export * from "./dataSyncManage.vue?vue&type=script&lang=js"

import "./dataSyncManage.vue?vue&type=style&index=0&id=1f9caa27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9caa27"]])

export default __exports__